export default __webpack_public_path__ + "static/media/santa-cruz-brand.5ccadc03.png";